const map = {
	"./airtable-1.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/airtable-1.png",
		[
			831927
		]
	],
	"./airtable.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/airtable.png",
		[
			817365
		]
	],
	"./asana.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/asana.png",
		[
			510851
		]
	],
	"./azure-devops.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/azure-devops.png",
		[
			376056
		]
	],
	"./backfill.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/backfill.png",
		[]
	],
	"./box.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/box.png",
		[
			446782
		]
	],
	"./confluence_dc.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/confluence_dc.png",
		[
			734019
		]
	],
	"./drive.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/drive.png",
		[
			606777
		]
	],
	"./dropbox.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/dropbox.png",
		[
			780147
		]
	],
	"./figma.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/figma.png",
		[
			598717
		]
	],
	"./freshservice.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/freshservice.png",
		[
			748892
		]
	],
	"./gitbook.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/gitbook.png",
		[
			70862
		]
	],
	"./github.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/github.png",
		[
			877112
		]
	],
	"./gitlab.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/gitlab.png",
		[
			147288
		]
	],
	"./gmail.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/gmail.png",
		[
			86851
		]
	],
	"./google-calendar.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/google-calendar.png",
		[
			58117
		]
	],
	"./hubspot.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/hubspot.png",
		[
			77896
		]
	],
	"./jira_dc.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/jira_dc.png",
		[
			245989
		]
	],
	"./jsm_dc.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/jsm_dc.png",
		[
			168359
		]
	],
	"./launchdarkly.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/launchdarkly.png",
		[
			800689
		]
	],
	"./lucid.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/lucid.png",
		[
			303494
		]
	],
	"./miro.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/miro.png",
		[
			118078
		]
	],
	"./monday.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/monday.png",
		[
			463157
		]
	],
	"./mural.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/mural.png",
		[
			625858
		]
	],
	"./notion.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/notion.png",
		[
			758834
		]
	],
	"./onedrive.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/onedrive.png",
		[
			561953
		]
	],
	"./outlook-calendar.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/outlook-calendar.png",
		[
			22193
		]
	],
	"./outlook-mail.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/outlook-mail.png",
		[
			103486
		]
	],
	"./pagerduty.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/pagerduty.png",
		[
			518188
		]
	],
	"./power-bi.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/power-bi.png",
		[
			446146
		]
	],
	"./salesforce.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/salesforce.png",
		[
			141916
		]
	],
	"./sentry.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/sentry.png",
		[
			751804
		]
	],
	"./servicenow.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/servicenow.png",
		[
			796410
		]
	],
	"./sharepoint.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/sharepoint.png",
		[
			882428
		]
	],
	"./slack.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/slack.png",
		[
			504429
		]
	],
	"./smartsheet.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/smartsheet.png",
		[
			274069
		]
	],
	"./stripe.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/stripe.png",
		[
			380650
		]
	],
	"./teams.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/teams.png",
		[
			879659
		]
	],
	"./todoist.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/todoist.png",
		[
			500857
		]
	],
	"./webex.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/webex.png",
		[
			653064
		]
	],
	"./zendesk.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/zendesk.png",
		[
			701081
		]
	],
	"./zeplin.png": [
		"../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape/zeplin.png",
		[
			33083
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../../integrated-teams/rovo-expansion/assets/banner-activation-images/desktop-and-tablet-landscape lazy recursive ^\\.\\/.*\\.png$ referencedExports: ";
module.exports = webpackAsyncContext;